// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 143) return "app.2cc51595b428447d0e43.css";
	// return url for filenames based on template
	return "" + chunkId + "." + {"70":"0effd7489e5ed6af50ed","224":"452196fd477f0027a891"}[chunkId] + ".css";
};